export default {
    get UserToken() {
        return localStorage.getItem('token')
    },
    set UserToken(value) {
        localStorage.setItem('token', value)
    },
    userInfo: {
        loginname: '',
        avatar_url: '',
        userId: '',
        token: ''
    },
    /* 导航菜单是否折叠 */
    isSidebarNavCollapse: false,
    /* 隐藏菜单栏 */
    isHiddenMenu: false,
    isHiddenTop: false,
    /* 是否为数据显示页面 */
    isStatisticsPage: false,
}
